import moment, {Moment} from 'moment';

export interface StatusMessage {
  status: string;
  message: string;
}

export const gqlStatusMessage = `
  status
  message
`;

export interface PaginatiorInfo {
  currentPage: number
  lastPage: number
  total: number
}

export const gqlPaginatorInfo = `
  paginatorInfo {
      currentPage
      lastPage
      total
  }
`;

export const OPERATOR = {
  EQ: 'EQ',
  NEQ: 'NEQ',
  GT: 'GT',
  GTE: 'GTE',
  LT: 'LT',
  LTE: 'LTE',
  LIKE: 'LIKE',
  NOT_LIKE: 'NOT_LIKE',
  IN: 'IN',
  IS_NULL: 'IS_NULL',
  BETWEEN: 'BETWEEN',
  NOT_IN: 'NOT_IN',
};

export interface WhereConstraints {
  column?: string,
  operator?: string,
  value?: any,
  OR?: WhereConstraints[],
  AND?: WhereConstraints[],
}

export const DataTypes = {
  STRING: 'string',
  BOOLEAN: 'boolean',
  NUMBER: 'number',
  DATE: 'date',
};

export const conditions: ConditionSchema[] = [
  {
    type: DataTypes.STRING,
    conditions: [
      {label: 'equal', value: '=', test: (a: string, b: string) => a === b},
      {label: 'not equal', value: '!=', test: (a: boolean, b: boolean) => a !== b},
    ],
    cast: (a: string) => a
  },
  {
    type: DataTypes.BOOLEAN,
    conditions: [
      {label: 'equal', value: '=', test: (a: boolean, b: boolean) => a === b},
      {label: 'not equal', value: '!=', test: (a: boolean, b: boolean) => a !== b},
    ],
    cast: (a: string) => a === 'true'
  },
  {
    type: DataTypes.NUMBER,
    conditions: [
      {label: 'equal', value: '=', test: (a: number, b: number) => a === b},
      {label: 'not equal', value: '!=', test: (a: number, b: number) => a !== b},
      {label: 'less than', value: '<', test: (a: number, b: number) => a < b},
      {label: 'greater than', value: '>', test: (a: number, b: number) => a > b},
      {label: 'less than or equal', value: '<=', test: (a: number, b: number) => a <= b},
      {label: 'greater than or equal', value: '>=', test: (a: number, b: number) => a >= b},
    ],
    cast: (a: string) => Number(a)
  },
  {
    type: DataTypes.DATE,
    conditions: [
      {label: 'equal', value: '=', test: (a: Moment, b: Moment) => a.isSame(b)},
      {label: 'not equal', value: '!=', test: (a: Moment, b: Moment) => !a.isSame(b)},
      {label: 'less than', value: '<', test: (a: Moment, b: Moment) => !a.isBefore(b)},
      {label: 'greater than', value: '>', test: (a: Moment, b: Moment) => !a.isAfter(b)},
      {label: 'less than or equal', value: '<=', test: (a: Moment, b: Moment) => !a.isSameOrBefore(b)},
      {label: 'greater than or equal', value: '>=', test: (a: Moment, b: Moment) => !a.isSameOrAfter(b)},
    ],
    cast: (a: string) => moment(new Date(a))
  },
];

export interface ConditionSchema {
  type: string,
  conditions: Array<{
    label: string,
    value: string,
    test: (a: any, b: any) => boolean
  }>,
  cast: (a: string) => any,
}

export interface AttributeSchema {
  value: string,
  type: string,
  label: string
  defaultValue?: string,
  options?: Array<{
    label: string,
    value: string,
  }>
}

export interface TypeSchema {
  value: string,
  label: string,
  atts: AttributeSchema[]
}


export interface CmsCopy {
  __typename?: string | undefined
  id: number
  key: string
  body: string
  is_html: boolean
}
